import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, kicker, title, dark = false }) => (
  <div className="relative mb-14 sm:mb-20">
    <span
      className={`pointer-events-none absolute -top-10 sm:-top-16 left-0 font-mono font-black text-[7rem] sm:text-[10rem] lg:text-[13rem] leading-none select-none ${dark ? "text-bone/[0.07]" : "text-ink/[0.05]"}`}
      aria-hidden="true"
    >
      {num}
    </span>
    <Reveal>
      <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.35em] mb-4 ${dark ? "text-saffron" : "text-crimson"}`}>
        Chapter {num} — {kicker}
      </p>
      <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl ${dark ? "text-bone" : "text-ink"}`}>
        {title}
      </h2>
    </Reveal>
  </div>
);

export const CountUp = ({ to, suffix = "", className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: EASE,
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);
  return (
    <span ref={ref} className={className}>
      {val}
      {suffix}
    </span>
  );
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
